/* eslint-disable camelcase */

export interface IServerProfile {
  id: number
  username: string
  date_joined: string
  balance_currency: Date
  balance: string
  is_banned: boolean
}

export interface IProfile {
  id: number
  username: string
  dateJoined: string
  balanceCurrency: Date
  balance: string
  isBanned: boolean
}

export interface IServerUserInfo {
  first_name: string
  last_name: string
  date_of_birth: string
  mobile_number: string
  postal_code: string
  street_address: string
  country: string
  city: string
  gender: string
}

export interface IUserInfo {
  email?: string
  firstName: string
  lastName: string
  gender: string
  dateOfBirth: string
  mobileNumber?: string
  postalCode: string
  streetAddress: string
  country: string
  city: string
}

export interface IUserInfoPayload {
  firstName: string
  lastName: string
  gender: string
  dateOfBirth: string
  mobileNumber?: string
  postalCode: string
  streetAddress: string
  country: string
  city: string
}

export interface IWithdrawalPayload {
  amount: number
  currency: string
  senderId: number
  recipientId: number | null
}

export interface IWithdrawalApiPayload {
  amount: number
  currency: string
  sender_id: number
  recipient_id: number | null
}
export const ProfileTabs = {
  MENU: 'menu',
  PROFILE: 'profile',
  BET_HISTORY: 'betHistory',
  BET_HISTORY2: 'betHistory2',
  // SPIN_HISTORY: 'spinHistory',
  SLOTS_HISTORY: 'slotsHistory',
  DEPOSIT: 'deposit',
  BONUSES: 'transferBonus',
  PROMOTIONS: 'promotions',
  CHANGE_PASSWORD: 'changePassword',
  TRANSACTIONS: 'transactions',
  LOGOUT: 'logout',
} as const

export type ProfileTabsType = ReverseMap<typeof ProfileTabs>
